import axios from "axios";
import { getAPIUrl } from "../config";
import { headerConfig } from "./authConfig";
const serviceEndPoint = `${getAPIUrl()}/api/process`;

// this should come from DB 
const allProcesses = [
  {
    _id: '63c56cfb5ae72461a240ce43',
    processName: "Update SSL Certificate",
    createdAt: "",
    createdBy: "userID",
    steps: [
      "scp whitelistingCategories.zip anjali@theaccessmedicine.com:./",
      "ssh  anjali@theaccessmedicine.com",
      "mv /home/anjali/whitelistingCategories.zip /home/cms/",
      "cd chome/cms/",
      "mkdir category-whitelist",
      "mv whitelistingCategories.zip category-whitelist/",
      "cd category-whitelist/",
      "unzip whitelistingCategories.zip",
      "npm i",
      "cp -r env.txt .env",
      "vim .env (make changes accordingly)",
      "vim index.js",
      "Comment this line await client.hSet('rxs_categories', formattedCategories);",
      "node index.js",
      "vim index.js",
      "Uncomment the line that was commented above.<br/>node index.js<br/>"
    ]
  },
  {
    _id: '63c56cfb5ae72461a240ce73',
    processName: "Document Verification",
  },
  // Add more processes as needed
];

export const getAllProcess = () => {
  return allProcesses;
};

export const getProcessData = async () => {
  try {
    const result = await axios.get(serviceEndPoint, headerConfig());
    return result.data;
  } catch (error) {
    console.error("Error fetching process data:", error);
    throw error;
  }
};

export const addProcessData = async (data) => {
  try {
    const result = await axios.post(serviceEndPoint, data, headerConfig());
    return result.data;
  } catch (error) {
    console.error("Error adding process data:", error);
    throw error;
  }
};

export const getProcessById = async (siteId) => {
  try {
    const result = await axios.get(
      `${serviceEndPoint}/${siteId}`,
      headerConfig()
    );
    return result.data;
  } catch (error) {
    console.error(`Error fetching process by ID (${siteId}):`, error);
    throw error;
  }
};

export const updateProcessData = async (data) => {
  try {
    const result = await axios.put(
      serviceEndPoint,
      {
        id: data._id,
        name: data.name,
        password: data.password,
        email: data.email,
        phone: data.phone,
        active: data.active,
        role: data.role,
      },
      headerConfig()
    );
    return result.data;
  } catch (error) {
    console.error("Error updating process data:", error);
    throw error;
  }
};

export const deleteProcess = async (id) => {
  try {
    const result = await axios.delete(serviceEndPoint, {
      data: { id },
      ...headerConfig(),
    });
    return result.data;
  } catch (error) {
    console.error("Error deleting process:", error);
    throw error;
  }
};